import SentimentSatisfiedIcon from '@material-ui/icons/SentimentSatisfied';

function OkayEmoji() {
  return (
    <SentimentSatisfiedIcon
      style={{
        border: '1px solid black',
        background: 'yellow',
        fontSize: '36px',
        color: 'black',
      }}
    />
  );
}

export default OkayEmoji;
